import { staticFileLocation } from '@server/constants';
import theme from '@styles/theme';
import { FC, ReactNode } from 'react';
import {
  AppCustomizationIcon,
  BuildingIcon,
  CelebrationIcon,
  GetSomeHiredIcon,
  HiringPageIcon,
  PickYourPlanIcon,
  StandoutInCrowdIcon,
} from '../../../../vectors/index';
import { Box, Breakpoint, css } from '@mui/system';
import { Typography } from '@mui/material';
import { bold, semibold } from '@styles/fontWeights';
import { darkBlue } from '@styles/colors';

type Step = {
  label: string;
  subtitle?: string;
  subtitle2?: string;
  content: ReactNode;
  nextLabel: string;
  disableNext?: boolean;
  modalMaxWidth?: Breakpoint;
  showLogo?: boolean;
};

type OnboardingStepTitilesProps = {
  activeStep: number;
  steps: Step[];
};

const OnboardingStepTitiles: FC<OnboardingStepTitilesProps> = ({
  activeStep,
  steps,
}) => {
  return (
    <>
      {activeStep === 0 ? (
        <img
          src={`${staticFileLocation}img/logos/LogoStampShadow.png`}
          css={css`
            max-width: 50px;
            width: 100%;
            margin-right: ${theme.spacing(2)};
            margin-top: 20px;
          `}
          alt="Notifications"
        />
      ) : (
        activeStep !== 4 && (
          <Box pt={5}>
            {activeStep === 1 && <HiringPageIcon />}
            {activeStep === 5 && <StandoutInCrowdIcon />}
            {activeStep === 2 && <BuildingIcon />}
            {activeStep === 3 && <GetSomeHiredIcon />}
            {activeStep === 4 && <AppCustomizationIcon />}
            {activeStep === 6 && <PickYourPlanIcon />}
            {activeStep === 7 && <CelebrationIcon />}
          </Box>
        )
      )}
      {activeStep !== 4 && (
        <>
          <Typography
            variant={activeStep === 3 ? 'subtitle1' : 'h1'}
            sx={{
              p: 3,
              fontSize:
                activeStep === 3 ? '28px !important' : '36px !important',
            }}
            fontWeight={semibold}
            lineHeight={activeStep === 3 ? 1.2 : 1.4}
            dangerouslySetInnerHTML={{ __html: steps[activeStep].label }}
          />
          {steps[activeStep].subtitle && (
            <Typography
              lineHeight={1.2}
              fontSize={activeStep === 1 ? 16 : 18}
              mt={activeStep === 1 || activeStep === 3 ? 1 : 0}
              color={activeStep === 1 || activeStep === 3 ? 'gray' : ''}
              dangerouslySetInnerHTML={{ __html: steps[activeStep].subtitle }}
            />
          )}
          {steps[activeStep].subtitle2 && (
            <Typography
              lineHeight={1.2}
              fontSize={15}
              mt={1.5}
              dangerouslySetInnerHTML={{ __html: steps[activeStep].subtitle2 }}
            />
          )}
          {activeStep === 0 && (
            <Typography
              variant="subtitle1"
              lineHeight={1.2}
              color={darkBlue}
              fontWeight={bold}
              sx={{ fontSize: '18px !important' }}
            >
              Follow a few easy steps and we'll have <br />
              you fully set up in just a few minutes.
            </Typography>
          )}
        </>
      )}
    </>
  );
};

export default OnboardingStepTitiles;
